var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.desc))]),_c('hr'),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.isLoading},on:{"click":_vm.exportCSV}},[_vm._v(" "+_vm._s(_vm.isLoading ? 'Downloading...' : 'Download Export')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }